import wrapperHOC from "@Utils/wrapperHOC";
import SDKInfo from "../SDKInfo/SDKInfo";
import styles from "./PersonalInfoContainer.module.scss";

const ChinesePersonalInfo = () => (
  <>
    <div className={styles.headingContainer}>
      <h1 className={`${styles.title} is-2 has-text-centered`}>第三方个人信息共享清单</h1>
    </div>
    <br />
    <br />

    {/* Content */}
    <div className={styles.containerSmall}>
      <div className={styles.row}>
        <>
          <div className={styles.introSection}>
            <p>
              <span>
                当您使用由第三方提供的服务时，我们将在取得或确保该第三方已取得您授权同意后，或在法律法规允许的其他情形下，向其共享相应的信息。您可通过本文件列出的相关信息了解第三方如何处理您的个人信息。同时，我们将严格规范第三方对个人信息的获取行为，以保障您的个人信息安全。
              </span>
            </p>
            <p>
              <span>
                为确保<strong>AmberStudent</strong>
                的稳定运行或实现相关功能，我们可能会接入第三方提供的软件开发工具包（SDK），以实现前述目的。以下为已集成的相关第三方
                SDK
                清单。您可点击“查看详情”或根据目录中提供的路径查看第三方的数据使用及保护规则。请注意，第三方
                SDK
                可能因版本升级、政策调整等原因而改变其处理的个人信息类型，最准确的信息请以其官方公布的说明为准。
              </span>
            </p>
          </div>

          <hr className={styles.sectionDivider} />
          {/* SDK Information */}
          <SDKInfo />

          <hr className={styles.sectionDivider} />
          {/* Third-Party Service Information Sharing List */}
          <h1 className={styles.sectionTitle}>第三方服务信息共享清单</h1>
          <p>
            当您使用由第三方提供的服务时，我们将在取得或确保该第三方已取得您授权同意后，或在法律法规允许的其他情形下，向其共享相应的信息。您可通过本文件了解第三方如何处理您的个人信息。我们将严格监管第三方对个人信息的收集，以确保您的信息安全。
          </p>

          <h3 className={styles.sectionSubTitle} id="cross-border-data-transfer-zh">
            跨境数据传输
          </h3>
          <p>
            部分 SDK 服务提供商位于中国境外（如美国、新加坡、欧盟等）。当这些 SDK
            收集个人信息时，您的数据可能会被传输至境外服务器。
            我们确保此类传输符合中国相关法律法规的要求，并仅在获得您的明确同意后进行。
          </p>
          {/* Housing application section */}
          <>
            <h3 className={styles.sectionSubTitle}>• 房源申请</h3>
            <strong>在线房源申请</strong>
            <p>
              <strong>收集的个人信息(必须)：</strong>
              中文姓名、名（拼音）、姓（拼音）、出⽣⽇期、性别、⼿机号码、电⼦邮箱、护照国籍/地区、留学学校名称
            </p>
            <p>
              <strong>收集的个人信息(可选)：</strong> 根据申请的房源不同可能会需要提供以下部分信息
              申请人信息：留学入学年级、留学大学专业（英文）、当前就读院校、住址信息（所在地区、联系地址、邮政编码）身份证号或护照号、身份证照片或扫描件、护照照片及扫描件、护照失效时间、Student
              ID、签证照片或扫描件、财产证明、签证I-20或DS2019表照片或扫描件、是否携带宠物、入学时间、美国驾照号、留学大学专业中文名称、留学大学课程时间
            </p>
            <p>
              <strong>担保人信息：</strong>
              中文姓名、名（拼音）、姓（拼音）、与申请人的关系、出生日期、手机号、邮箱、性别、担保人地址（所在地区、联系地址、邮政编码）
            </p>
            <p>
              <strong>紧急联系人信息：</strong>
              中文姓名、名（拼音）、姓（拼音）、与您的关系、出生日期、手机号、邮箱、性别、紧急联系人地址（所在地区、联系地址、邮政编码）
            </p>
            <p>
              <strong>使用目的： </strong>用于为你提交房源预订申请
            </p>
            <p>
              <strong>使用场景： </strong>在房源详情页的户型和租期的申请入口在线提交租房申请表
            </p>
            <p>
              <strong>第三方名称：</strong>
              平台房源持有者或管理者(订单详情页-我也已经阅读并同意《订房授权书》《公寓退订政策》查看)
            </p>
            <p>
              <strong>共享方式：</strong>API接口加密传输、邮件发送、在线安全填报
            </p>
          </>

          {/* Payment processing section */}
          <>
            <h3 className={styles.sectionSubTitle}>• 房源申请</h3>
            <ul>
              <li>
                <strong>Stripe 支付服务</strong>
                <ul>
                  <li>
                    <strong>收集的个人信息：</strong> 姓名、电子邮箱、支付卡信息、账单地址、交易详情
                  </li>
                  <li>
                    <strong>使用目的：</strong> 处理预订、押金及房租支付
                  </li>
                  <li>
                    <strong>使用场景：</strong> 在应用内完成支付交易
                  </li>
                  <li>
                    <strong>第三方名称：</strong> Stripe, Inc.
                  </li>
                  <li>
                    <strong>共享方式：</strong> API 接口加密传输
                  </li>
                  <li>
                    <strong>隐私政策详情：</strong> 点击查看详情
                  </li>
                  <li>
                    <strong>联系方式：</strong> support@stripe.com
                  </li>
                </ul>
              </li>
            </ul>
          </>

          {/* Data Analysis and Attribution section */}
          <>
            <h3 className={styles.sectionSubTitle}>• 数据分析与归因</h3>
            <ul>
              <li>
                <strong>Singular 分析服务</strong>
                <ul>
                  <li>
                    <strong>收集的个人信息：</strong> 设备标识符（IDFA、GAID）、IP
                    地址、安装来源、应用使用事件、广告活动数据、应用内购买信息
                  </li>
                  <li>
                    <strong>使用目的：</strong> 评估广告效果、进行归因分析及营销优化
                  </li>
                  <li>
                    <strong>使用场景：</strong> 应用安装与使用过程中自动采集
                  </li>
                  <li>
                    <strong>第三方名称：</strong> Singular Labs, Inc.
                  </li>
                  <li>
                    <strong>共享方式：</strong> API 接口加密传输
                  </li>
                  <li>
                    <strong>隐私政策详情：</strong> 点击查看详情
                  </li>
                  <li>
                    <strong>联系方式：</strong> privacy@singular.net
                  </li>
                </ul>
              </li>
            </ul>
          </>
          {/* Analytics and Marketing section */}
          <>
            <h3 className={styles.sectionSubTitle}>• 分析与营销</h3>
            <ul>
              <li>
                <strong>Amplitude 分析服务</strong>
                <ul>
                  <li>
                    <strong>收集的个人信息：</strong>{" "}
                    设备标识符、使用模式、用户交互、功能使用、性能数据
                  </li>
                  <li>
                    <strong>使用目的：</strong> 理解用户行为，改进应用功能，优化用户体验
                  </li>
                  <li>
                    <strong>使用场景：</strong> 应用使用过程中自动收集
                  </li>
                  <li>
                    <strong>第三方名称：</strong> Amplitude, Inc.
                  </li>
                  <li>
                    <strong>共享方式：</strong> API 接口加密传输
                  </li>
                  <li>
                    <strong>隐私政策详情：</strong> 点击查看详情
                  </li>
                  <li>
                    <strong>联系方式：</strong> privacy@amplitude.com
                  </li>
                </ul>
              </li>
            </ul>
          </>

          <p>
            本清单将根据 <strong>AmberStudent</strong>{" "}
            服务的不断改进而定期更新，我们可能会新增或替换第三方服务以优化您的使用体验。
          </p>
        </>
      </div>
    </div>
  </>
);

export default wrapperHOC(ChinesePersonalInfo, {
  componentName: "ChinesePersonalInfo",
  showForChina: true,
});
